export const SQL_JS_CONFIG = {
	// sql.js version - 1.6.2
	locateFile: file => `/public/${file}`,
}
